import React, { useEffect, useState } from 'react';
import getUserRanking from '../services/getUserRankingServices';
import rankingForEventServices from '../services/rankingForEventServices';
import './Ranking.css';

const RankingList = () => {
    const [dataRanking, setDataRanking] = useState([]);
    const [errors, setErrors] = useState(null);
    const token = localStorage.getItem('token');

    // Consultamos los rankings
    const handleSubmit = async () => {
        try {
            const response = await getUserRanking(token);
            setDataRanking(response);
            setErrors(null);
        } catch (error) {
            console.log(error)
            setErrors(error.message);
        }
    }

    useEffect(() => {
        setInterval(() => {
            handleSubmit();
            console.log("fecth")
        }, 2000)
    }, [token]);

    return (
        <>
            <div className='d-block d-md-block d-lg-none d-xl-none'>
                {/* design for celular */}
                <div className="external-container d-flex justify-content-center align-items-center vh-100">
                    <div className="container d-flex justify-content-center align-items-center flex-column">
                        <div className="col-12 m-0 p-0 mt-5">
                            <div className="col-12 d-flex justify-content-center align-items-center mt-1">
                                <img src="./aviancaLogo.png" className="container-logo mt-5" alt="logo" />
                            </div>
                        </div>
                        <div className='container d-flex justify-content-center align-items-center'>
                            <div className='row mt-5'>
                                <h1 className='text-center tolowercase h1 title-formulario other-color-title'>Ranking</h1>
                                <div className="triangle-text">
                                    <p className="text-white text-center mt-3 fs-1">Este es el ranking
                                        de los que gritan
                                        los goles con el alma</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 m-0 p-0 mb-1">
                            <div className="d-flex justify-content-center align-items-center flex-column">
                                <div className="col-12 col-lg-8 d-flex justify-content-center align-items-center flex-column">
                                    <div className="col-11 col-lg-8 d-flex justify-content-center align-items-center flex-column">
                                        {/* contain the badges */}
                                        <div className='container mt-4'>
                                            <div className='row'>
                                                <div className='col-7'>
                                                    <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Nombre</span>
                                                </div>
                                                <div className='col-5'>
                                                    <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Puntaje</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-container register-container text-center text-white mt-3">
                                            <div className='container'>
                                                <div className='row'>
                                                    {dataRanking.map((data) => (
                                                        <React.Fragment key={data.id}>
                                                            <div className='text-red col-8 text-start fw-bold text-start f-avianca-text'>{data.user__name} - ***{data.user__dni.slice(-4, -1)}</div>
                                                            <div className='text-red col-4 text-end fw-bold f-avianca-text'>{data.total_points}pts</div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                                {errors && <p className="error-message m-0 p-0 text-white fw-bold">{"No hay un evento activo en este momento"}</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* footer mobile */}
                    <footer className="d-block d-md-block d-lg-none d-xl-none col-12 mt-auto">
                        <div className="d-flex justify-content-between align-items-center text-white mb-2">
                            <div className='mx-4 mb-3'>
                                <img src="./Logo-SuperTransporte.png" style={{ width: '150%' }} alt="logo" />
                            </div>
                            <div className='text-end mx-4 mb-3'>
                                <img src="./Logo-Footer-2.png" style={{ width: '70%', marginLeft: '-85px' }} alt="logo" />
                            </div>
                        </div>
                    </footer>


                </div>
            </div>

            {/* design for tablet and pc */}
            <div className='d-none d-md-none d-lg-block d-xl-block'>
                <div className="external-container d-flex justify-content-center align-items-center vh-100">
                    <header className="header">
                        <nav className="navbar navbar-expand-md fixed-top navbar-light bg-transparent">
                            <div className="container-fluid d-flex justify-content-end align-items-center">
                                <a className="navbar-brand order-3">
                                    <img src="./aviancaLogo.png" className="mx-3 img-fluid" alt="logo" />
                                </a>
                            </div>
                        </nav>
                    </header>

                    <div className="container d-flex justify-content-center align-items-center flex-column mt-5 pt-2 100vh">
                        <div className="col-12 m-0 p-0">
                            <h1 className="text-center title-text-ranking mt-5 other-color-title fw-bold">ranking</h1>
                            <h3 className='text-center title-xl-3 mt-1 text-white'>Este es el ranking
                                de los que gritan
                                los goles con el alma:
                            </h3>
                            <div className="col-12 m-0 p-0 mb-1">
                                <div className="d-flex justify-content-center align-items-center flex-column">
                                    <div className="col-12 col-lg-8 d-flex justify-content-center align-items-center flex-column">
                                        <div className="col-11 col-lg-12 d-flex justify-content-center align-items-center flex-column">
                                            {/* contain the badges */}
                                            <div className='container mt-4'>
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Nombre</span>
                                                    </div>
                                                    <div className='col-6'>
                                                        <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Puntaje</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-container register-container text-center text-white mt-3">
                                                <div className='container'>
                                                    <div className='row'>
                                                        {dataRanking.map((data) => (
                                                            <React.Fragment key={data.id}>
                                                                <div className='text-red col-8 text-start fw-bold text-start f-avianca-text'>{data.user__name} - ***{data.user__dni.slice(-4, -1)}</div>
                                                                <div className='text-red col-4 text-end fw-bold f-avianca-text'>{data.total_points}pts</div>
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                    {errors && <p className="error-message m-0 p-0 text-white fw-bold">{"No hay un evento activo en este momento"}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer className="col-12 mt-auto bg-transparent">
                        <div className="d-flex justify-content-between align-items-center text-white mb-2">
                            <div className='mx-4 mb-3'>
                                <img src="./Logo-SuperTransporte.png" style={{ width: '80%' }} alt="logo" />
                            </div>
                            <div className='text-end mx-4 mb-3'>
                                <img src="./Logo-Footer-2.png" style={{ width: '60%' }} alt="logo" />
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </>
    );
}

const WinnerRanking = () => {
    const [dataRanking, setDataRanking] = useState([]);
    const [errors, setErrors] = useState(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        const fetchData = async () => {
            try {
                setInterval(async () => {
                    // Llamar a la función para obtener el ranking
                    const response = await getUserRanking(token);

                    // Ordenar los usuarios por puntos totales (de mayor a menor)
                    response.sort((a, b) => b.total_points - a.total_points);

                    // Asignar el rango a cada usuario
                    response.forEach((user, index) => {
                        user.rank = index + 1; // El índice comienza en 0, por eso se suma 1
                    });

                    // Actualizar el estado con los datos del ranking
                    setDataRanking(response);
                }, 2000);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [token]);

    return (
        <>
            <div className='d-block d-md-none d-lg-none d-xl-none'>
                <div className="events-container w-100">
                    <div className="row external-bg-container-include d-flex justify-content-center align-items-start pt-5 vh-100 overflow-y-scroll">
                        <div className="container d-flex justify-content-center align-items-center flex-column">
                            <div className="col-12 m-0 p-0 mt-5">
                                <div className="col-12 d-flex justify-content-center align-items-center mt-1">
                                    <img src="./aviancaLogo.png" className="container-logo mt-5" alt="logo" />
                                </div>
                            </div>

                            <div className="container d-flex justify-content-center align-items-center flex-column">
                                <div className="row">
                                    <h1 className="text-center tolowercase h1 title-formulario other-color-title">Ganadores</h1>
                                    <div className="triangle-text">
                                        <h1 className="text-white text-center mt-3">
                                            ¡Con su grito volaron
                                            <br />
                                            muy lejos!
                                        </h1>
                                    </div>
                                </div>
                                <div className="container mt-5">
                                    <div className='container mt-4'>
                                        <div className='row'>
                                            <div className='col-6'>
                                                <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Nombre</span>
                                            </div>
                                            <div className='col-6'>
                                                <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Puntaje</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-container register-container text-center text-white mt-3">
                                        <div className='container'>
                                            <div className='row d-flex justify-content-center align-items-center'>
                                                {dataRanking.map((winner, index) => (
                                                    <div key={winner.id} className={`col-12 col-md-6 mb-3 ${index < 3 ? 'order-md-1' : 'order-md-2'}`}>
                                                        <div className="winner">
                                                            <div className="rank fs-1" style={{ color: 'red' }}>{winner.rank} puesto</div>
                                                            <span className='badge-custom fs-1'>{winner.user__name} - {`000${winner.total_points}`} db</span> <br />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {errors && <p className="error-message m-0 p-0 text-white fw-bold">{"No hay un evento activo en este momento"}</p>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* footer mobile */}
                        <footer className="d-block d-md-block d-lg-none d-xl-none col-12 mt-auto">
                            <div className="d-flex justify-content-between align-items-center text-white mb-2">
                                <div className='mx-4 mb-3'>
                                    <img src="./Logo-SuperTransporte.png" style={{ width: '150%' }} alt="logo" />
                                </div>
                                <div className='text-end mx-4 mb-3'>
                                    <img src="./Logo-Footer-2.png" style={{ width: '70%', marginLeft: '-85px' }} alt="logo" />
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>


            {/* design for tablet and pc */}
            <div className='d-none d-md-block d-lg-block d-xl-block'>
                <div className="events-container w-100">
                    <div className="row external-bg-container-include d-flex justify-content-center align-items-start pt-5 vh-100 overflow-y-scroll">
                        <header className="header mb-5">
                            <nav className="navbar navbar-expand-md fixed-top navbar-light bg-transparent">
                                <div className="container-fluid d-flex justify-content-end align-items-center">
                                    <button className="navbar-toggler order-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                    <a className="navbar-brand order-3">
                                        <img src="./aviancaLogo.png" className="mx-3 img-fluid" alt="logo" />
                                    </a>
                                </div>
                            </nav>
                        </header>

                        <div className="container d-flex justify-content-center align-items-center flex-column">
                            <div className="row">
                                <h1 className="text-center tolowercase h1 title-formulario other-color-title">Ganadores</h1>
                                <div className="triangle-text">
                                    <h1 className="text-white text-center mt-3">
                                        ¡Con su grito volaron
                                        <br />
                                        muy lejos!
                                    </h1>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 m-0 p-0 mb-1">
                            <div className="d-flex justify-content-center align-items-center flex-column">
                                <div className="col-12 col-lg-8 d-flex justify-content-center align-items-center flex-column">
                                    <div className="col-11 col-lg-12 d-flex justify-content-center align-items-center flex-column">
                                        {/* contain the badges */}
                                        <div className='container mt-4'>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Nombre</span>
                                                </div>
                                                <div className='col-6'>
                                                    <span className="w-100 text-red other-badge-custom badge rounded-pill fw-bold mt-1 mb-1 p-3 fs-1">Puntaje</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-container register-container text-center text-white mt-3">
                                            <div className='container'>
                                                <div className='row d-flex justify-content-center align-items-center'>
                                                    {dataRanking.map((winner, index) => (
                                                        <div key={winner.id} className={`col-12 col-md-6 mb-3 ${index < 3 ? 'order-md-1' : 'order-md-2'}`}>
                                                            <div className="winner">
                                                                <div className="rank fs-1" style={{ color: 'red' }}>{winner.rank} puesto</div>
                                                                <span className='badge-custom fs-1'>{winner.user__name} - {`000${winner.total_points}`} db</span> <br />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {errors && <p className="error-message m-0 p-0 text-white fw-bold">{"No hay un evento activo en este momento"}</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <footer className="col-12 mt-auto bg-transparent">
                            <div className="d-flex justify-content-between align-items-center text-white mb-2">
                                <div className='mx-4 mb-3'>
                                    <img src="./Logo-SuperTransporte.png" style={{ width: '70%' }} alt="logo" />
                                </div>
                                <div className='text-end mx-4 mb-3'>
                                    <img src="./Logo-Footer-2.png" style={{ width: '35%' }} alt="logo" />
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>


        </>
    )
}

const DataViewRanking = ({ eventId, nameEvent }) => {
    const [dataRanking, setDataRanking] = useState([]);
    const [errors, setErrors] = useState(null);
    const token = localStorage.getItem('token');

    // Consultamos los rankings
    const handleSubmit = async () => {
        try {
            const response = await rankingForEventServices(eventId);
            setDataRanking(response);
            setErrors(null);
        } catch (error) {
            console.log(error);
            setErrors(error.message);
        }
    };

    useEffect(() => {
        if (eventId) {
            handleSubmit();
            console.log("fetch");
        }
    }, [token, eventId]);

    return (
        <>
            {/* Código para el diseño móvil */}
            <div className='d-block d-md-block d-lg-none d-xl-none'>
                {/* Resto del código móvil */}
            </div>

            {/* Diseño para tablet y PC */}
            <div className='d-block d-md-block d-lg-block d-xl-block'>
                <div className="external-container d-flex justify-content-center align-items-center vh-100">
                    <div className="container d-flex align-items-center flex-column mt-5 pt-2 100vh">
                        <div className="col-12 m-0 p-0">
                            <div className="container table-container" style={{ maxHeight: '470px' }}>
                                <table className="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th className='bg-transparent text-center title-text-ranking mt-1 text-white'>Nombre</th>
                                            <th className='bg-transparent text-center title-text-ranking mt-1 text-white'>Puntaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataRanking.map((data) => (
                                            <tr key={data.id}>
                                                <td className='text-red text-center fw-bold fs-4'>{data.user__name} - ***{data.user__dni.slice(-4)}</td>
                                                <td className='text-red text-center fw-bold fs-4'>{data.total_points} pts</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export {
    RankingList,
    WinnerRanking,
    DataViewRanking
};
